<app-pwa-install-banner class="d-lg-none"></app-pwa-install-banner>

<ngx-ui-loader></ngx-ui-loader>
<router-outlet></router-outlet>